import React from 'react'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import Head from 'next/head'
import HeadMeta from '../components/HeadMeta'
import { GlobalNav } from '../components/GlobalNav'

const OitanaviPage = () => {
  return (
    <div>
      <HeadMeta title="GROUP VISION 2050 | 株式会社ベツダイ" description="BETSUDAI Co., Ltd Group VISION 2050" />
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header />
        </div>
        <div className="c-page-sub__globalnav" data-sponly>
          <GlobalNav />
        </div>
        <div className="c-page-sub__main">
          <main>
            <article>
              <div className="c-page-sub__content-main">
                <section data-type="section">
                  <div className="c-groupvision">
                    <div className="c-groupvision_mainImage">
                      <img src="/img/image_groupvision01.png" alt="" />
                    </div>
                    <h2 className="c-groupvision_title01">
                      BETSUDAI Co., <br className="spOnly" />Ltd Group VISION 2050
                    </h2>
                    <h3 className="c-groupvision_title02">
                      ベツダイグループでは、<br className="spOnly" />今後想定される様々な将来の<br className="spOnly" />環境変化を踏まえた上で、<br />
                      グループの長期経営戦略として、<br className="spOnly" />「GROUP VISION 2050 」を策定しました。<br />
                      「GROUP VISION 2050 」では、VISONARITYを新たなスローガンとして掲げ、<br />
                      多様なグリーンの力で、人々の暮らしだけでなく、心までより豊かにすること。<br />
                      そして、その豊かさを次世代につなげていくことを使命とし、すべての人が、笑顔で気持ちよく暮らせる未来を創造していきます。
                    </h3>
                    <div className="groupvisionInfo">
                      <div className="title01">
                        基本戦略
                      </div>
                      <div className="wrapper01">
                        <div className="item item01">
                          <img src="/img/icon_ groupvision01.png" alt="" />
                          <div>
                            <div className="itemTitle">
                             「街」に、やさしい
                            </div>
                            <div className="itemText">
                              外構植栽における生物多様性保全への取り組みとして建設時における植栽に対する長期景観管理計画を指します。
                            </div>
                          </div>
                        </div>
                        <div className="item item02">
                          <img src="/img/icon_ groupvision02.png" alt="" />
                          <div>
                            <div className="itemTitle">
                             「住まい」に、やさしい
                            </div>
                            <div className="itemText">
                              お住いの植栽計画について魅力をお伝えするため、植栽のご説明や育て方のレクチャーを行ったり、その季節に合ったイベントなどを企画、開催します。
                            </div>
                          </div>
                        </div>
                        <div className="item item03">
                          <img src="/img/icon_ groupvision03.png" alt="" />
                          <div>
                            <div className="itemTitle">
                            「人」に、やさしい
                            </div>
                            <div className="itemText">
                              ベツダイオリジナルシリーズ「Oita Craft 」では暮らしをデザインする。 環境にも人にもやさしい「家具づくり」に取り組みます。
                            </div>
                          </div>
                        </div>
                        <div className="item item04">
                          <img src="/img/icon_ groupvision04.png" alt="" />
                          <div>
                            <div className="itemTitle">
                             「自然」に、やさしい
                            </div>
                            <div className="itemText">
                              地球や環境負荷をかけずに豊かに暮らす。 私たちは、暮らしで欠かせない恵みを、ゆたかな自然からいただいています。グリーンなマインドで未来を創りましょう。
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="title01">
                        ACTION（事業領域への展開）
                      </div>
                      <div className="wrapper01">
                        <div className="title02">
                          GREEN LABEL
                        </div>
                      <div className="list01">
                        <div className="item">
<span>①</span> <p>計画段階から竣工後10 年先の緑の生長に伴う景観の形成を見据え、シンボルツリーを贈呈。各物件の特性に合わせた景観管理計画を策定。</p>
                        </div>
                        <div className="item">

<span>②</span> <p>①で定めた景観設計と管理計画を実現するための植栽を最適な形で施工。</p>
                        </div>
                        <div className="item">

<span>③</span> <p>竣工後は、施工時よりも景観が良化した10 年後を迎えられるよう植栽を管理すると共に、生物多様性に配慮した施肥・省薬剤管理によって多様な生物が集う土台を生み出す。</p>
                        </div>
                        <div className="item">

<span>④</span> <p>時を経て緑が生長し、景観が豊かになっていく家庭を居住者様に見える化し、共有することで、居住者様に緑への愛着や想い・理解を深めていただける住まいを実現。</p>
                        </div>
                        <div className="item">

<span>⑤</span> <p>室内グリーンコーディネイトや緑化などグリーンセミナーを開催。お住まいの植栽計画について魅力をお伝えするため、植栽のご説明や育て方のレクチャーを行ったり、季節にあったイベントなどを企画・開催。</p>
                        </div>
                        <div className="item">

<span>⑥</span> <p>地球や環境負荷をかけず豊かに暮らす。私たちは、暮らしに欠かせない恵みを、豊かな自然からいただいています。グリーンなマインドで未来を創りましょう。</p>
                        </div>
                        <div className="item">

<span>⑦</span> <p>外構植栽における生物多様性保全への取り組みとして、建設時における植栽に対する長期景観管理計画を示します。</p>
                        </div>
                        <div className="item">

<span>⑧</span> <p>SDGs への取り組み、エネルギーをみんなに、そしてクリーンに。住み続けられるまちづくり。</p>
                        </div>
                      </div>
                      </div>
                    </div>
                    
                    <div className="c-groupvision_logo">
                      <img src="/img/logo2025_2.svg" alt="BETSUDAI"></img>
                    </div>
                    <div className="c-groupvision_fotterImage">
                      <img src="/img/image_groupvision02.png" alt="" />
                    </div>
                  </div>
                </section>



                
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default OitanaviPage
